/* eslint-disable new-cap */
/* eslint-disable max-depth */
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useEffect, useState, useCallback } from "react";
import { httprequest } from "../../../data/api";
import useStyles from "../styles";
import { toast } from "react-toastify";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react/dist/iconify.js";
import CardCount from "../component/CardCount";
import { Grid, useMediaQuery } from "@mui/material";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Badge from "../../../components/Badge";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/Modal";
import PageLoader from "../../../components/PageLoader";
import { uploadFile } from "../../../hooks/useUpload";
import ReactDOMServer from "react-dom/server";
import PublishTemplateForPDF from "../component/PublishTemplate";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const CLASSES_ENDPOINT = "/api/v1/teacher/classes";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const REPORT_ENDPOINT = "/api/v1/reports";
const MARK_REPORT_ENDPOINT = "/api/v1/student-reports/";

const ReportTemplate = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const [classesData, setClassData] = useState([]);
  const [value, setValue] = useState("1");
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const navigate = useNavigate();
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const [reportToPublish, setReportToPublish] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [isClassLoading, setIsClassLoading] = useState(false);
  const [isReportLoading, setIsReportLoading] = useState(false);
  const [batchAction, setBatchAction] = useState(null);
  const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [batchPrintModalOpen, setBatchPrintModalOpen] = useState(false);
  const [batchPrintUrls, setBatchPrintUrls] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isPublishing, setIsPublishing] = useState(false);

  const getAllClasses = () => {
    setIsClassLoading(true);
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.map(item => item.class) || [];
        setClassData(physicalClasses);
        setIsClassLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
        setIsClassLoading(false);
      })
      .finally(() => {
        setIsClassLoading(false);
      });
  };

  /**
     * Fetches all terms for a specific session and updates the state.
     * @function
     * @param {string|number} Session_ID - The ID of the session to get terms for.
     * @returns {void}
     * @description Makes an HTTP GET request to TERM_ENDPOINT and filters the results
     * to only include terms matching the provided Session_ID.
     */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
     * Fetches all sessions from the server and updates the state.
     * @async
     * @function
     * @returns {Promise<void>}
     * @description Makes an asynchronous HTTP GET request to GET_SESSIONS endpoint,
     * updates the allSessions state with the response data, and sets the active session.
     */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
     * Finds the active term in the current session.
     * @description This variable holds the term object where is_current is true     */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
     * Handles session change events.
     * @function
     * @description Gets the selected Session_ID from the event and calls getAllTerms with it.
     */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  const getAllReport = useCallback(async (classId = "", termId = "") => {
    setIsReportLoading(true);
    try {
      let url = REPORT_ENDPOINT;
      const params = new URLSearchParams();

      // Always include termId if it's provided
      if (termId) params.append("term_id", termId);

      // Only include classId if it's provided and not "1" (which appears to be your "All" tab value)
      if (classId && classId !== "1") params.append("class_id", classId);

      if (params.toString()) url += `?${params.toString()}`;

      const res = await httprequest.get(url);
      setReportData(res.data.data);
      setFilteredData(res?.data?.data);
    } catch (err) {
      toast.error(err.response?.message || "Failed to fetch reports");
    } finally {
      setIsReportLoading(false);
    }
  }, []);
  /**
         * @description When active_term_session changes, updates the selected term state.
         * @deps active_term_session
         */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
    }
  }, [active_term_session]);

  /**
         * @effect
         * @description When activeSession changes, gets all terms for the active session.
         * @deps activeSession
         */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getAllReport(value !== "1" ? value : "", selectedTermId);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    getAllReport(newValue !== "1" ? newValue : "", aselectedTerm);
  };

  const handleViewReport = (row) => {
    if (row?.report_id) {
      navigate(`/report/viewreport/${row.report_id}`);
    } else if (row?.student_id) {
      const queryParams = new URLSearchParams();

      const termId = row.term_id || aselectedTerm;
      if (termId) queryParams.append("term_id", termId);

      const classId = row.class_id || row.class?.id;
      if (classId) queryParams.append("class_id", classId);

      if (!termId) {
        toast.warning("Term ID is required to view this report");

        return;
      }

      navigate(`/report/viewreport/student/${row.student_id}?${queryParams.toString()}`);
    } else {
      toast.warning("No valid report or student identifier found");
    }
  };
  const handleEditReport = (row) => {
    if (row?.report_id) {
      navigate(`/report/editreport/${row.report_id}`);
    } else if (row?.student_id) {
      const queryParams = new URLSearchParams();

      const termId = row.term_id || aselectedTerm;
      if (termId) queryParams.append("term_id", termId);

      const classId = row.class_id || row.class?.id;
      if (classId) queryParams.append("class_id", classId);

      if (!termId) {
        toast.warning("Term ID is required to view this report");

        return;
      }

      navigate(`/report/editreport/student/${row.student_id}?${queryParams.toString()}`);
    } else {
      toast.warning("No valid report or student identifier found");
    }
  };

  const handleBatchActionSelect = (action) => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one report");

      return;
    }
    setBatchAction(action);
    setIsBatchModalOpen(true);
  };

  const generateReportPDF = async (reportId) => {
    let tempDiv = null;

    try {
    // Fetch report data
      const response = await httprequest.get(`/api/v1/student-report?report_ids=${reportId}`);
      const reportData = Array.isArray(response.data.data)
        ? response.data.data[0]
        : response.data.data;

      // Create temporary container
      tempDiv = document.createElement("div");
      tempDiv.style.width = "794px"; // A4 width in pixels
      tempDiv.style.padding = "20px";
      tempDiv.style.boxSizing = "border-box";
      document.body.appendChild(tempDiv);

      // Add critical CSS for PDF rendering
      const style = document.createElement("style");
      style.textContent = `
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      table {
        border-collapse: collapse !important;
        width: 100% !important;
      }
      th, td {
        border: 1px solid #e0e0e0 !important;
        padding: 8px 12px !important;
      }
      thead th {
        background-color: #f9fafb !important;
        font-weight: 500 !important;
      }
    `;
      tempDiv.appendChild(style);

      // Render the component
      const htmlString = ReactDOMServer.renderToString(
        <PublishTemplateForPDF reportData={reportData} />
      );
      tempDiv.innerHTML = htmlString;

      // Wait for resources to load
      await new Promise(resolve => {
        const images = tempDiv.getElementsByTagName("img");
        if (images.length === 0) return resolve();

        let loaded = 0;
        const onLoad = () => {
          loaded++;
          if (loaded === images.length) resolve();
        };

        Array.from(images).forEach(img => {
          if (img.complete) onLoad();
          else img.addEventListener("load", onLoad);
          img.addEventListener("error", onLoad);
        });
      });

      // Add small delay to ensure rendering completes
      await new Promise(resolve => setTimeout(resolve, 500));

      // Generate PDF
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: true,
        backgroundColor: "#FFFFFF",
        allowTaint: true,
        ignoreElements: (element) => {
        // Ignore elements that might interfere with table rendering
          return element.classList.contains("MuiDataGrid-menuIcon") ||
               element.classList.contains("MuiDataGrid-columnSeparator");
        }
      });

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: [794, 1123] // A4 dimensions
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.92);
      const imgWidth = pdf.internal.pageSize.getWidth() - 40; // Add margins
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 20, 20, imgWidth, imgHeight);

      // Clean up
      document.body.removeChild(tempDiv);

      return pdf.output("blob");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("PDF generation failed:", error);
      if (tempDiv && tempDiv.parentNode) {
        document.body.removeChild(tempDiv);
      }
      throw error;
    }
  };

  const uploadAndPublishReport = async (reports) => {
    try {
      const pdfGenerationPromises = reports.map(async (report) => {
        try {
          const pdfBlob = await generateReportPDF(report.report_id);

          return {
            report,
            pdfBlob,
            studentName: `${report.last_name} ${report.first_name}`
          };
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`Failed to generate PDF for ${report.last_name} ${report.first_name}:`, error);

          return {
            report,
            error: `PDF generation failed: ${error.message}`
          };
        }
      });

      const pdfResults = await Promise.all(pdfGenerationPromises);

      const uploadPromises = pdfResults
        .filter(result => result.pdfBlob)
        .map(async ({ report, pdfBlob, studentName }) => {
          try {
            const documentData = await uploadFile(
              pdfBlob,
              `${studentName.replace(/\s+/g, "_")}_report.pdf`
            );
            const document = documentData[0];

            return {
              report_id: report.report_id,
              document: {
                upload_id: document.upload_id,
                file_url: document.file_url,
                name: `${studentName} Report`
              }
            };
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Failed to upload PDF for ${studentName}:`, error);

            return {
              report_id: report.report_id,
              error: `File upload failed: ${error.message}`
            };
          }
        });

      const uploadResults = await Promise.all(uploadPromises);

      const successfulUploads = uploadResults.filter(result => !result.error);
      const failedUploads = uploadResults.filter(result => result.error);

      if (failedUploads.length > 0) {
        // eslint-disable-next-line no-console
        console.error("Some reports failed to upload:", failedUploads);
        if (successfulUploads.length === 0) {
          throw new Error("All report uploads failed");
        }
      }

      const response = await httprequest.post("/api/v1/student-reports/publish", {
        reports: successfulUploads
      });

      return {
        success: true,
        message: `${successfulUploads.length} reports published successfully`,
        failedReports: failedUploads,
        data: response.data
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Batch publish failed:", error);

      return {
        success: false,
        message: error.response?.data?.message || error.message
      };
    }
  };

  const handleBatchPrint = async (reportIds) => {
    try {
      const response = await httprequest.get("/api/v1/student-report", {
        params: { report_ids: reportIds.join(",") }
      });

      const reportsData = response.data.data;
      const pdfUrls = [];

      // Process reports sequentially to avoid memory issues
      for (const report of reportsData) {
        try {
          const pdfBlob = await generateReportPDF(report.report_id);
          const pdfUrl = URL.createObjectURL(pdfBlob);
          pdfUrls.push({
            url: pdfUrl,
            name: `${report.last_name}_${report.first_name}_report.pdf`
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`Failed to generate PDF for ${report.last_name}:`, error);
        // Continue with other reports even if one fails
        }
      }

      setBatchPrintUrls(pdfUrls);
      setBatchPrintModalOpen(true);

      // Clean up URLs after modal closes
      return () => {
        pdfUrls.forEach(item => URL.revokeObjectURL(item.url));
      };
    } catch (error) {
      toast.error(`Failed to prepare reports for printing: ${error.message}`);
    }
  };

  const handleConfirmBatchAction = async () => {
    try {
      if (selectedRows.length === 0) {
        toast.warning("Please select at least one report");

        return;
      }
      const reportIds = selectedRows.map(row => row.report_id);

      const toastId = toast.loading(`Processing 0 of ${selectedRows.length} reports...`);

      let successCount = 0;
      const results = [];

      for (let i = 0; i < selectedRows.length; i++) {
        const row = selectedRows[i];
        const studentName = `${row.last_name} ${row.first_name}`;

        try {
          toast.update(toastId, {
            render: `Processing ${i + 1} of ${selectedRows.length}: ${studentName}`,
            isLoading: true
          });

          let result;

          switch (batchAction) {
          case "publish":
          case "publish_send":
            // eslint-disable-next-line no-case-declarations
            const publishResults = await uploadAndPublishReport(selectedRows);

            if (publishResults.success) {
              successCount = selectedRows.length;

              if (batchAction === "publish_send") {
                await httprequest.post(`${REPORT_ENDPOINT}/send`, {
                  report_ids: selectedRows.map(row => row.report_id)
                });
              }
            }

            selectedRows.forEach(row => {
              results.push({
                ...row,
                success: publishResults.success,
                message: publishResults.message
              });
            });
            break;
          case "print":
            await handleBatchPrint(reportIds);
            break;

          case "unpublish":
            result = await httprequest.post(`${REPORT_ENDPOINT}/unpublish`, {
              report_ids: [row.report_id]
            });
            result = { success: true, message: result.data.message };
            break;

          case "ready":
            result = await httprequest.patch(
              `${MARK_REPORT_ENDPOINT}ready-for-publish`,
              { report_ids: selectedRows.map(row => row.report_id) }
            );

            selectedRows.forEach(row => {
              results.push({
                ...row,
                success: true,
                message: result.data.message
              });
            });
            successCount = selectedRows.length;
            break;

          default:
            break;
          }

          if (result?.success) {
            successCount++;
          }
          results.push({ ...row, ...result });
        } catch (error) {
          results.push({
            ...row,
            success: false,
            message: error.response?.data?.message || error.message
          });
        }
      }

      // Final status
      if (successCount === selectedRows.length) {
        toast.update(toastId, {
          render: `Successfully processed all ${successCount} reports`,
          type: "success",
          isLoading: false,
          autoClose: 2000
        });
      }
      if (successCount > 0) {
        toast.update(toastId, {
          render: `Processed ${successCount} of ${selectedRows.length} reports successfully`,
          type: "success",
          isLoading: false,
          autoClose: 2000
        });
      }
      setIsBatchModalOpen(false);
      setBatchAction(null);
      getAllReport();
    } catch (error) {
      toast.error(`Batch operation failed: ${error.message}`);
    }
  };

  const handlePrintClick = async (report) => {
    try {
      setSelectedReport(report);
      setPrintModalOpen(true);

      const pdfBlob = await generateReportPDF(report.report_id);
      const pdfUrl = URL.createObjectURL(pdfBlob);

      setSelectedReport(prev => ({ ...prev, pdfUrl }));
    } catch (error) {
      toast.error(`Failed to generate PDF: ${error.message}`);
      setPrintModalOpen(false);
    }
  };

  const handlePublishReport = async () => {
    setIsPublishing(true);
    try {
      const pdfBlob = await generateReportPDF(reportToPublish.report_id);

      // Upload PDF
      const documentData = await uploadFile(
        pdfBlob,
        `${reportToPublish.last_name}_${reportToPublish.first_name}_report.pdf`
      );

      const document = documentData[0];

      const response = await httprequest.post("/api/v1/student-reports/publish", {
        reports: [{
          report_id: reportToPublish.report_id,
          document: {
            upload_id: document.upload_id,
            file_url: document.file_url,
            name: `${reportToPublish.last_name} ${reportToPublish.first_name} Report`
          }
        }]
      });

      toast.success(response.data.message);
      setIsPublishing(false);
      setReportToPublish("");
      setPublishModalOpen(false);

      await getAllReport();
    } catch (error) {
      toast.error(`Failed to publish report: ${error.response?.data?.message || error.message}`);
    } finally {
      setIsPublishing(false);
    }
  };

  const handlePublishClick = (report) => {
    setReportToPublish(report);
    setPublishModalOpen(true);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Name</p>}
          {row.last_name} {row.first_name}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row.class?.name}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column" }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row.status} />
        </p>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => handleViewReport(row)}>
            <Icon icon="hugeicons:view" />
          </button>
          {row.status !== "published" ?
            <button
              className="table-action-icon"
              onClick={() => handleEditReport(row)}
            >
              <Icon icon="lucide:edit" />
            </button> : ""}
          {row.status === "ready_for_publish" ?
            <button className="table-action-icon" onClick={() => handlePublishClick(row)}>
              <Icon icon="entypo:publish" />
            </button> : ""}
          {row.status === "published" ?
            <button className="table-action-icon" onClick={() => handlePrintClick(row)}>
              <Icon icon="fluent:print-32-regular" />
            </button>
            : ""}
        </div>
      )
    }
  ];
  useEffect(() => {
    setFilteredData(reportData);
  }, [reportData]);
  const publishedCount = reportData.filter(r => r.status === "published").length;
  const inReviewCount = reportData.filter(r => r.status === "in_review").length;

  const handleSearch = (e) => {
    const { value } = e.target;

    if (!value) {
      setFilteredData(reportData);

      return;
    }

    const searchValue = value.toLowerCase();
    const searchTerms = searchValue.split(" ");

    const result = reportData.filter((report) => searchTerms.every(term => (report?.last_name && report.last_name.toLowerCase().includes(term)) ||
      (report?.first_name && report.first_name.toLowerCase().includes(term)) ||
      (report?.class?.name && report.class.name.toLowerCase().includes(term)) ||
      (report?.status && report.status.toLowerCase().includes(term))
    )
    );

    setFilteredData(result);
  };

  useEffect(() => {
    getAllSessions();
    getAllReport("", active_term_session?.id); // Pass empty classId and active termId
    getAllTerms();
    getAllClasses();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Reports"
          subtitle="Manage students reports here."
        />
        <TabContext value={value}>
          <div className="page-content margin-top-16">
            {classesData.length > 0 && (
              <div className="tablist-container">
                <Tabs
                  className="overide-tablist"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="All" value="1" />
                  {isClassLoading ? (
                    <div className="container-left">
                      <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
                    </div>
                  ) : (
                    classesData?.map((data) => {
                      return (
                        <Tab
                          key={data?.id}
                          value={data?.id}
                          label={data?.name}
                        />
                      );
                    })
                  )}
                </Tabs>
              </div>
            )}
            <div className={classes.headinfo}>
              <div className="flex gap-10 align-items-end margin-top-5">
                <div>
                  {allSessions?.length > 0 && (
                    <SelectGroup
                      children={
                        <select
                          value={activeSession?.id || ""}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
                <div>
                  {selectedSessionTerms?.length > 0 && (
                    <SelectGroup
                      children={
                        <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="margin-bottom-30 margin-top-16">
              <Grid container spacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <CardCount
                    title="Total No. of Reports"
                    icon={<Icon icon="iconamoon:file-thin" />}
                    count={reportData.length}

                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <CardCount
                    title="Report Published"
                    icon={<Icon icon="iconamoon:file-thin" />}
                    count={publishedCount}
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <CardCount
                    title="In Review"
                    icon={<Icon icon="fluent:document-arrow-right-24-regular" />}
                    count={inReviewCount}
                  />
                </Grid>
              </Grid>
            </div>
            <TabPanel sx={{ padding: "0px !important" }} value="1" className="tabpanel-overide">
              {isReportLoading ? (
                <PageLoader />
              ) :
                <Table
                  data={filteredData}
                  columns={columns}
                  subHeader={true}
                  pagination
                  handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows)}
                  subHeaderComponent={
                    <div className="action_div">
                      <TableSearch
                        placeholder="Search here..."
                        searchTableFunc={handleSearch}

                      />
                      <SelectGroup
                        children={
                          <select
                            onChange={(e) => {
                              const action = e.target.value;
                              if (action) {
                                handleBatchActionSelect(action);
                                e.target.value = "";
                              }
                            }}
                          >
                            <option value="">Batch Actions</option>
                            <option value="publish">Batch Publish Reports</option>
                            <option value="print">Batch Print Reports</option>
                          </select>
                        }
                      />
                    </div>
                  }
                />}
            </TabPanel>
            {classesData?.map((data) => {
              return (
                <TabPanel sx={{ padding: "0px !important" }} key={data?.id} value={data?.id}>
                  {isReportLoading ? (
                    <PageLoader />
                  ) :
                    <Table
                      data={reportData}
                      columns={columns}
                      subHeader={true}
                      pagination
                      handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows)}
                      subHeaderComponent={
                        <div className="action_div">
                          <TableSearch
                            placeholder="Search here..."
                            searchTableFunc={handleSearch}

                          />
                          <SelectGroup
                            children={
                              <select
                                onChange={(e) => {
                                  const action = e.target.value;
                                  if (action) {
                                    handleBatchActionSelect(action);
                                    e.target.value = "";
                                  }
                                }}
                              >
                                <option value="">Batch Actions</option>
                                <option value="publish">Batch Publish Reports</option>
                                <option value="print">Batch Print Reports</option>
                              </select>
                            }
                          />
                        </div>
                      }
                    />}
                </TabPanel>
              );
            })}
          </div>
        </TabContext>
        {/* Print Modal */}
        <Modal
          title="Print Report"
          subtitle={`Print report for ${selectedReport?.last_name || ""} ${selectedReport?.first_name || ""}`}
          isopen={printModalOpen}
          closeModal={() => {
            setPrintModalOpen(false);
            if (selectedReport?.pdfUrl) {
              URL.revokeObjectURL(selectedReport.pdfUrl);
            }
          }}
          modalContent={
            <div style={{ textAlign: "center", padding: "20px" }}>
              <p>Choose an action for this report:</p>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "20px" }}>
                <Button
                  variant="primaryoutline"
                  buttonSize="medium"
                  color="btnfontprimary"
                  buttonName="View PDF"
                  onClick={() => {
                    if (selectedReport?.pdfUrl) {
                      window.open(selectedReport.pdfUrl, "_blank");
                      setPrintModalOpen(false);
                    }
                  }}
                />
                <Button
                  variant="primary"
                  buttonSize="medium"
                  color="btndefault"
                  buttonName="Download PDF"
                  onClick={async () => {
                    try {
                      // Generate the PDF blob
                      const pdfBlob = await generateReportPDF(selectedReport.report_id);

                      // Create download link
                      const link = document.createElement("a");
                      const pdfUrl = URL.createObjectURL(pdfBlob);
                      link.href = pdfUrl;
                      link.download = `${selectedReport.last_name}_${selectedReport.first_name}_report.pdf`;
                      document.body.appendChild(link);
                      link.click();

                      // Clean up
                      setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(pdfUrl);
                      }, 100);

                      setPrintModalOpen(false);
                    } catch (error) {
                      toast.error(`Failed to download PDF: ${error.message}`);
                    }
                  }}
                />
              </div>
            </div>
          }
          modalFooter={
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Print Now"
                onClick={() => {
                  if (selectedReport?.pdfUrl) {
                    const iframe = document.createElement("iframe");
                    iframe.style.display = "none";
                    iframe.src = selectedReport.pdfUrl;
                    document.body.appendChild(iframe);
                    iframe.onload = () => {
                      iframe.contentWindow.print();
                    };
                    setPrintModalOpen(false);
                  }
                }}
              />
            </div>
          }
        />
        {/* Publish Modal */}
        <Modal
          title="Publish Report"
          subtitle={`Publish report for  ${reportToPublish?.last_name} ${reportToPublish?.first_name}`}
          isopen={publishModalOpen}
          closeModal={() => setPublishModalOpen(false)}
          modalFooter={
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                isLoading={isPublishing}
                color="btndefault"
                buttonName="Confirm Publish"
                onClick={handlePublishReport}
              />
            </div>
          }
        />
        <Modal
          title={`Confirm Batch ${batchAction?.replace("_", " ")?.toUpperCase()}`}
          isopen={isBatchModalOpen}
          closeModal={() => {
            setIsBatchModalOpen(false);
            setBatchAction(null);
          }}
          modalContent={
            <div>
              <p>Are you sure you want to {batchAction?.replace("_", " ")} {selectedRows?.length || 0} selected reports?</p>
              {selectedRows?.length > 0 && (
                <ul style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {(Array.isArray(selectedRows) ? selectedRows : []).slice(0, 5).map(row => (
                    <li key={row.report_id}>
                      {row.last_name}, {row.first_name} - {row.class?.name}
                    </li>
                  ))}
                  {selectedRows?.length > 5 && <li>...and {selectedRows.length - 5} more</li>}
                </ul>
              )}
            </div>
          }
          modalFooter={
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                variant="primaryoutline"
                buttonSize="full"
                color="btnfontprimary"
                buttonName="Cancel"
                onClick={() => {
                  setIsBatchModalOpen(false);
                  setBatchAction(null);
                }}
              />
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName={`Confirm ${batchAction?.replace("_", " ")}`}
                onClick={handleConfirmBatchAction}
              />
            </div>
          }
        />
        {/* Batch Print Modal */}
        <Modal
          title="Batch Print Reports"
          isopen={batchPrintModalOpen}
          closeModal={() => {
            setBatchPrintModalOpen(false);
            // Clean up object URLs after a delay to ensure downloads complete
            setTimeout(() => {
              batchPrintUrls.forEach(item => URL.revokeObjectURL(item.url));
              setBatchPrintUrls([]);
            }, 10000); // 30 second delay to ensure all downloads complete
          }}
          modalContent={
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <p>{batchPrintUrls.length} reports ready for download:</p>
              <ul style={{ marginTop: "10px" }}>
                {batchPrintUrls.map((item, index) => (
                  <li key={index} style={{ marginBottom: "5px" }}>
                    {item.name || `Report ${index + 1}`}
                  </li>
                ))}
              </ul>
            </div>
          }
          modalFooter={
            <div>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Download All"
                onClick={() => {
                  batchPrintUrls.forEach((item, index) => {
                    setTimeout(() => {
                      const link = document.createElement("a");
                      link.href = item.url;
                      link.download = item.name || `report_${index + 1}.pdf`;
                      link.style.display = "none";
                      document.body.appendChild(link);
                      link.click();

                      setBatchPrintModalOpen(false);

                      setTimeout(() => {
                        document.body.removeChild(link);
                      }, 100);
                    }, index * 1000);
                    setBatchPrintModalOpen(false);
                  });

                  // Show completion message
                  setTimeout(() => {
                    toast.success(`Initiated download of ${batchPrintUrls.length} reports`);
                  }, batchPrintUrls.length * 1000);
                }}
              />
              {/* <Button
                variant="primary"
                buttonSize="medium"
                color="btndefault"
                buttonName="Print All"
                onClick={() => {
                  batchPrintUrls.forEach(item => {
                    const iframe = document.createElement("iframe");
                    iframe.style.display = "none";
                    iframe.src = item.url;
                    document.body.appendChild(iframe);
                    iframe.onload = () => {
                      iframe.contentWindow.print();
                      setTimeout(() => {
                        document.body.removeChild(iframe);
                      }, 10000);
                    };
                  });
                  toast.info(`Opening ${batchPrintUrls.length} reports for printing`);
                }}
              /> */}
            </div>
          }
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default ReportTemplate;
